








































import Vue from 'vue'
import { Prop } from 'vue-property-decorator'
import Component from 'vue-class-component'
import RuleCondition from './RuleCondition.vue'
import {
  RuleEngineFact,
  RuleConditionType,
  RuleEngineCondition,
  RuleEngineOperator,
  RuleEngineEvent,
  RuleEventType,
  RuleEngineRule as IRuleEngineRule
} from '../utils/types'

@Component({
  components: { RuleCondition }
})
export default class RuleEngineRule extends Vue {
  @Prop(Array) events!: RuleEngineEvent[]
  @Prop(Array) facts!: RuleEngineFact[]
  @Prop(Array) operators!: RuleEngineOperator[]
  @Prop(Object) rule!: IRuleEngineRule
  eventType = RuleEventType

  private get isEventHasSimpleParam () {
    return this.rule.eventType === RuleEventType.USER_MESSAGE || this.rule.eventType === RuleEventType.ADD_SHIFT_INFO
  }

  private get selectableEvents () {
    return this.events.map(e => ({ text: e.name, value: e.type }))
  }

  handleConditionAddChild (condition: RuleEngineCondition) {
    if (condition.children) {
      condition.children.push({ type: RuleConditionType.FACT })
    }
  }

  handleConditionTypeClicked (
    condition: RuleEngineCondition,
    type: RuleConditionType
  ) {
    if (type === RuleConditionType.FACT) {
      this.$set(condition, 'children', undefined)
      return
    }
    this.$set(condition, 'children', [{ type: RuleConditionType.FACT }])
  }

  handleConditionRemoveChild (condition: RuleEngineCondition, index: number) {
    if (condition.children) {
      condition.children.splice(index, 1)
    }
  }
}
